export default Object.freeze({
  EXTERNAL: 'EXTERNAL',
  FILE: 'FILE',
  CONTENT: 'CONTENT',
  BLOG: 'BLOG',
  CALL_TO_ACTION: 'CALL_TO_ACTION',
  PAYMENT: 'PAYMENT',
  EMAIL_ADDRESS: 'EMAIL_ADDRESS',
  PHONE_NUMBER: 'PHONE_NUMBER',
  WHATSAPP_NUMBER: 'WHATSAPP_NUMBER'
});